export default function Logo({ className = "", compact = false }) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      <svg viewBox="0 0 100 100" className="h-9 w-9 shrink-0" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <defs>
          <linearGradient id="logo-grad" x1="0" y1="0" x2="100" y2="100">
            <stop offset="0%" stopColor="#00F5D4" />
            <stop offset="50%" stopColor="#7B2CBF" />
            <stop offset="100%" stopColor="#F4A261" />
          </linearGradient>
        </defs>
        <circle cx="50" cy="50" r="40" stroke="url(#logo-grad)" strokeWidth="2.5" strokeDasharray="4 4" />
        <ellipse cx="50" cy="50" rx="34" ry="14" transform="rotate(-25 50 50)" stroke="url(#logo-grad)" strokeWidth="3" />
        <circle cx="50" cy="50" r="8" fill="#00F5D4" />
        <circle cx="71" cy="39" r="4" fill="#F4A261" />
      </svg>
      {!compact && (
        <span className="flex flex-col leading-none">
          <span className="font-display text-[15px] font-bold tracking-[0.08em] text-slate-50">
            COSMOS ROUTES
          </span>
          <span className="font-mono text-[9px] tracking-[0.32em] text-aurora/80 mt-1">
            EXPLORE · EXPERIENCE · BELONG
          </span>
        </span>
      )}
    </span>
  );
}
